import React, { useState } from "react";
import axios from "axios";
import "./RechercheModal.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReactivationModal({ onClose, noBur, defaultNoSeq }) {
  const [noSeq, setNoSeq] = useState((defaultNoSeq || "").slice(0, 9));
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resultat, setResultat] = useState(null);

  const rechercher = async () => {
    setError(""); setResultat(null); setInfo(null);
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/reactivation/demande`, {
        params: { no_seq: noSeq.trim(), no_bur: noBur },
      });
      setInfo(data);
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setLoading(false);
    }
  };

  const reactiver = async () => {
    if (!window.confirm(`Réactiver la demande ${info.noseqdaj} ?\nLe statut redeviendra « ${info.statut.split("-Fermé")[0]} ».`)) return;
    setLoading(true); setError("");
    try {
      const { data } = await axios.post(`${API}/reactivation/reactiver`, { pk_daj: info.pk_daj });
      setResultat(data);
      setInfo(null);
      setNoSeq("");
    } catch (e) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rech-overlay">
      <div className="rech-modal" data-testid="reactivation-modal" style={{ width: "min(640px, 94vw)" }}>
        <div className="rech-titlebar">
          <span>Réactivation des demandes fermées</span>
          <button className="rech-close" onClick={onClose} data-testid="reactivation-close" title="Fermer">×</button>
        </div>
        <div className="rech-body" style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", gap: 12, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div className="rech-field" style={{ maxWidth: 220 }}>
              <label>No de séquence (9 premiers caractères)</label>
              <input value={noSeq} maxLength={9}
                     onChange={e => setNoSeq(e.target.value)}
                     onKeyDown={e => e.key === "Enter" && rechercher()}
                     autoFocus data-testid="reactivation-noseq" />
            </div>
            <div className="rech-field" style={{ maxWidth: 80 }}>
              <label>Bureau</label>
              <input value={noBur} disabled data-testid="reactivation-bureau" />
            </div>
            <button className="rech-btn-primary" onClick={rechercher} disabled={loading}
                    data-testid="reactivation-btn-recherche">
              {loading ? "…" : "Rechercher"}
            </button>
          </div>
          {error && <div className="rech-error" style={{ marginTop: 8 }} data-testid="reactivation-error">{error}</div>}

          {info && (
            <div style={{ marginTop: 12 }} data-testid="reactivation-info">
              <table style={{ fontSize: 12, lineHeight: 1.8 }}>
                <tbody>
                  <tr><td style={{ color: "#555", paddingRight: 12 }}>No séquence</td><td><strong>{info.noseqdaj}</strong> (image {info.no_image})</td></tr>
                  <tr><td style={{ color: "#555", paddingRight: 12 }}>Requérant</td><td>{info.prenom} {info.nom} — né(e) le {info.date_naissance}</td></tr>
                  {info.avocat_confie && (
                    <tr><td style={{ color: "#555", paddingRight: 12 }}>Confié à</td><td>{info.avocat_confie}</td></tr>
                  )}
                  <tr><td style={{ color: "#555", paddingRight: 12 }}>Statut actuel</td><td style={{ color: "#a00", fontWeight: 600 }}>{info.statut}</td></tr>
                  <tr><td style={{ color: "#555", paddingRight: 12 }}>Fermée le</td><td>{info.date_fermeture || "—"} (code {info.code_fermeture})</td></tr>
                  {info.noref && (
                    <tr><td style={{ color: "#555", paddingRight: 12 }}>No référence</td><td>{info.noref}</td></tr>
                  )}
                </tbody>
              </table>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                <button className="rech-btn-secondary" onClick={() => { setInfo(null); setNoSeq(""); }}
                        data-testid="reactivation-btn-nouveau">Nouvelle recherche</button>
                <button className="rech-btn-primary" onClick={reactiver} disabled={loading}
                        style={{ background: "#1a7a1a" }}
                        data-testid="reactivation-btn-reactiver">Réactiver la demande</button>
              </div>
            </div>
          )}

          {resultat && (
            <div style={{ marginTop: 12, color: "#1a7a1a", fontSize: 12, fontWeight: 600 }}
                 data-testid="reactivation-resultat">
              Demande {resultat.noseqdaj} réactivée — statut : « {resultat.statut} »
              {resultat.noref_retire && <div>Le numéro de référence automatique a été retiré (aucun refus/attestation lié).</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
